import testsTypes from '../../constants/testsTypes'
export * from './getindex'
export * from './get'
export * from './getxlsx'

const reset_test = () => {
  return {
    type: testsTypes.reset_test
  }
}

const clear_test = () => {
  return {
    type: testsTypes.clear_test
  }
}

export {
  reset_test,
  clear_test,
}



// WEBPACK FOOTER //
// ./src/js/actions/tests/index.js